import { createUseStore } from "../../hooks/Events";

const [useQuickAccess, setQuickAccess] = createUseStore<any>({
  token: null,
  userData: null,
});

export { useQuickAccess, setQuickAccess };
